import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Container, Section, BackgroundImage } from '../components/common'

const Logo = styled.img`
  opacity: 0.8;
  width: 10em;
  margin-bottom: 1.5em;

  &:hover,
  &:focus {
    opacity: 1;
  }
`
const Footer = styled(Section)`
  font-weight: 400;

  * + h3 {
    margin-top: 2rem;
  }

  p {
    margin-bottom: 0.7rem;
  }
`

export default ({ menuItems }) => (
  <Footer thick dark relative>
    <BackgroundImage image={`${process.env.PUBLIC_URL}/bg_4.jpg`} opacity={0.2} />
    <Container relative>
      <h3>Contact</h3>
      <p>Email: <a href='mailto:info@goldcoastbotany.com.au'>info@goldcoastbotany.com.au</a></p>
      <p>Phone: 0411 694 258</p>
      <p>Post: P.O. Box 471, Mudgeeraba QLD 4213</p>
      <h3>Navigation</h3>
      <p><Link to='/'>Home</Link></p>
      { menuItems.map(menuItem => <p key={menuItem.path}><Link to={menuItem.path}>{menuItem.title}</Link></p>) }

    </Container>
    <Container taCenter relative>
      <Link to='/'>
        <Logo src={`${process.env.PUBLIC_URL}/gcb_logo.png`} alt='Gold Coast Botany' />
      </Link>
      <br />
      &copy; 2017 <Link to='/' title='Gold Coast Botany'>Gold Coast Botany</Link>
    </Container>
  </Footer>
)



// WEBPACK FOOTER //
// ./src/components/Footer.js